import APageHeading from './index.vue';

APageHeading.install = app => {
  app.component(APageHeading.name, APageHeading);
};

export default APageHeading;
